const videoReviewStatuses = {
  0: 'Pendente',
  1: 'Aprovado',
  2: 'Reprovado',
}

export default videoReviewStatuses
